
var $counterItems,
    bodyScrollVisibleUpdateTick = false;

$(document).ready(function($) {
  $counterItems = $('.js-counter-item');

  checkIfVisible();

  // Scroll event
  $(window).scroll(function() {
    checkIfVisible();
  });
});


// Functions
function checkIfVisible(force) {
  if (typeof force === 'undefined') force = false;

  if (force || !bodyScrollVisibleUpdateTick) {
    if ($counterItems.length > 0) {
      $counterItems.each(function () {
        if ($(this).isInViewport()) {
          countUp($(this));
        }
      });
    }
  }
  bodyScrollVisibleUpdateTick = true;
}

function format(nStr) {
  nStr += '';
  var x = nStr.split(',');
  var x1 = x[0];
  var x2 = x.length > 1 ? ',' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }
  return x1 + x2;
}

function countUp($element) {
  if ($element.hasClass('is-counting')) {
    return;
  }
  $element.addClass('is-counting');
  var countTo = $element.attr('data-count');
  var dataType = $element.attr('data-type');
  countTo = countTo.replace(/[^0-9]/, '');
  countTo = countTo.replace('.', '');

  $({countNum: 0}).delay(300).animate({
    countNum: countTo
  }, {
    duration: 5000,
    easing: 'linear',
    step: function () {
      if (dataType === 'year' ) {
        $element.text(Math.floor(this.countNum));
      } else {
        $element.text(format(Math.floor(this.countNum)));
      }
    },
    complete: function () {

      if (dataType === 'year' ) {
        $element.text(this.countNum);
      } else {
        $element.text(format(this.countNum));
      }
    }
  });
}
$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top + 200;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
